import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-ink" data-id="element-182">
      {/* Mobile / fallback background image */}
      <div className="absolute inset-0 lg:hidden" data-id="element-183">
        <img src="https://cdn.magicpatterns.com/uploads/6ykDuvTeFwtheciXQEuKJa/1.jpg" alt="" className="w-full h-full object-cover object-top opacity-40" data-id="element-184" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/80 via-ink/85 to-ink" data-id="element-185"></div>
      </div>

      {/* Desktop split layout */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 pt-44 lg:pt-52 pb-20 grid lg:grid-cols-12 gap-12 items-center" data-id="element-186">
        {/* Text Column */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="lg:col-span-7 text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-187">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-6 font-cinzel" data-id="element-188">
            Professional Dominance
          </p>
          <h1 className="font-cormorant text-bone text-5xl md:text-7xl lg:text-7xl xl:text-8xl font-light leading-[1.05] mb-8" data-id="element-189">
            Where Trust,
            <br data-id="element-190" />
            Discipline, and
            <br data-id="element-191" />
            Transformation
            <br data-id="element-192" />
            Meet
          </h1>
          <p className="text-silver text-lg md:text-xl max-w-xl mx-auto lg:mx-0 mb-12 font-light leading-relaxed" data-id="element-193">
            Experience the art of power exchange with a skilled, intuitive
            professional. Discretion, expertise, and transformative sessions
            tailored to your journey.
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center" data-id="element-194">
            <a href="#contact" className="px-8 py-4 bg-gold text-ink text-sm uppercase tracking-widest font-medium hover:bg-bone transition-all duration-300" data-id="element-195">
              Request a Consultation
            </a>
            <a href="#experiences" className="px-8 py-4 border border-gold text-gold text-sm uppercase tracking-widest hover:bg-gold hover:text-ink transition-all duration-300" data-id="element-196">
              Explore Services
            </a>
          </motion.div>
        </motion.div>

        {/* Portrait Column — desktop only */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1.2,
        delay: 0.3
      }} className="hidden lg:block lg:col-span-5 relative" data-id="element-197">
          <div className="relative aspect-[3/4] w-full max-w-md ml-auto" data-id="element-198">
            <div className="absolute -inset-4 border border-gold/30" data-id="element-199"></div>
            <div className="absolute -top-4 -left-4 w-16 h-16 border-t border-l border-gold/60" data-id="element-200"></div>
            <div className="absolute -bottom-4 -right-4 w-16 h-16 border-b border-r border-gold/60" data-id="element-201"></div>

            <img src="https://cdn.magicpatterns.com/uploads/6ykDuvTeFwtheciXQEuKJa/1.jpg" alt="Madam Yas" className="relative w-full h-full object-cover object-top" data-id="element-202" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent pointer-events-none" data-id="element-203"></div>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.a href="#about" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-gold z-10" aria-label="Scroll to about section" data-id="element-204">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-205">
          <ChevronDownIcon size={28} data-id="element-206" />
        </motion.div>
      </motion.a>
    </section>;
}